import React, { Component, useRef } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import ErrorBoundary from "../errorBoundary"
import CustomModal from "../customModal"
import Button from "../../components/button"

import { customModalStyle } from "./customActualModal"

import request from "../../utils/request"

const Container = styled.div`
  padding: 20px;
`

const Header = styled.div`
  text-align: justify;
  font-size: 30px;
  font-weight: bold;

  // margin-bottom: 40px;
`

class TaxInvoiceNameModal extends Component {
  static propTypes = {}

  constructor(props) {
    super(props)
    this.state = {
      text: "",
    }
  }

  componentDidMount() {
    let initialState = {}
    this.setState(initialState)

    if (this.props.inputValue) {
      this.setState({ text: this.props.inputValue })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ text: this.props.inputValue })
    }
  }

  closeModal = () => {
    this.props.closeModal(false)
  }

  updateTaxInvoiceName = () => {
    this.props.updateTaxInvoiceName(this.state.text)
  }

  submit = async () => {
    if (!this.props.user_id) {
      alert("No User ID")
      return
    }

    try {
      const result = await request
        .post(
          `customer/id/${this.props.user_id}/tax_invoice_name`,
          {
            tax_invoice_name: this.state.text,
          },
          false
        )
        .then((res) => res.data)
        .catch((err) => {
          console.log(err)
          alert("Error while saving tax invoice name")
          return
        })

      if (result) {
        this.props.updateTaxInvoiceName(this.state.text)
      }
    } catch (err) {
      console.log(err)
      return
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <CustomModal isOpen={this.props.isOpen} customStyle={customModalStyle}>
          <Container>
            <Header>Tax invoice name</Header>
            <input
              id="tax_invoice_name"
              className="form-control"
              placeholder=""
              value={this.state.text}
              onChange={(e) => {
                this.setState({ text: e.target.value })
              }}
            />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  this.closeModal()
                }}
                style={{ margin: "0 10px" }}
                label="Cancel"
                light
              />
              <Button
                onClick={() => {
                  this.submit()
                }}
                style={{ margin: "0 10px" }}
                type="submit"
                label="Save"
              />
            </div>
          </Container>
        </CustomModal>
      </ErrorBoundary>
    )
  }
}

TaxInvoiceNameModal.propstype = {
  closeModal: PropTypes.func.isRequired,
  updateTaxInvoiceName: PropTypes.func.isRequired,
}

export default TaxInvoiceNameModal
